module.exports = __webpack_public_path__ + "img/2_img.e8c2c0ce.png";